import { render, staticRenderFns } from "./ForumProfileView.vue?vue&type=template&id=213fee34&scoped=true&"
import script from "./ForumProfileView.vue?vue&type=script&lang=js&"
export * from "./ForumProfileView.vue?vue&type=script&lang=js&"
import style0 from "./ForumProfileView.vue?vue&type=style&index=0&id=213fee34&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "213fee34",
  null
  
)

export default component.exports